import ApiService from "@/services/api.service.js";

export const ApplicationService = {
    submitApplication: function(data) {
        return ApiService.post("/application", data);
    },

    submitConceptNote: function(data) {
        return ApiService.post("/concept-note", data);
    },

    changeApplicationStatus: function(data) {
        return ApiService.post("/application/change-status", data);
    },
    changeConceptApplicationStatus: function(data) {
        return ApiService.post("/application/cn-change-status", data);
    },

    changeRevisionStatus: function(data) {
        return ApiService.post("/application/change-revision-status", data);
    },

    requestRevision: function(data) {
        return ApiService.post("/application/request-revision", data);
    },

    validateRevision: function(data) {
        return ApiService.post("/application/validate-revision", data);
    },

    getGrantApplication: function(data) {
        return ApiService.get(
            "/application/grant?grant_id=" +
                data.grantId +
                "&application_id=" +
                data.applicationId
        );
    },

    getOngoing: function() {
        return ApiService.get("/application/ongoing");
    },

    getApplication: function(applicationId) {
        return ApiService.get("/application/" + applicationId);
    },

    getApplicationLight: function(applicationId) {
        return ApiService.get("/application-light/" + applicationId);
    },

    getApplications: function(data) {
        return ApiService.post("/applications", data);
    },

    getConceptNotes: function(data) {
        return ApiService.post("/concept-notes", data);
    },

    getAllApplicationsLight: function() {
        return ApiService.get("/all-applications-light");
    },

    getFilters: function(data) {
        return ApiService.post("/applications/filters", data);
    },

    getConceptFilters: function(data) {
        return ApiService.post("/concept-notes/filters", data);
    },

    exportApplication: function(data) {
        return ApiService.post("/application/export", data);
    },
    exportConceptApplication: function(data) {
        return ApiService.post("/concept-notes/export", data);
    },
    exportConceptNoteBulk: function(data) {
        return ApiService.post("/concept-notes/csv-export", data);
    }
};

export default ApplicationService;
